import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { showErrorToast } from "../../../../fnx/showError";
export var useErrorHandling = function (_a) {
    var errorQuoteAddFields = _a.errorQuoteAddFields, errorPlans = _a.errorPlans, errorPaymentMode = _a.errorPaymentMode, errorPatchQuote = _a.errorPatchQuote, setSeeToast = _a.setSeeToast, onClearPlansData = _a.onClearPlansData, onClearPaymentModeData = _a.onClearPaymentModeData, errorOneQuote = _a.errorOneQuote, errorComplete = _a.errorComplete, errorReprintType = _a.errorReprintType;
    var t = useTranslation().t;
    useEffect(function () {
        if (errorQuoteAddFields) {
            showErrorToast(errorQuoteAddFields, setSeeToast, t);
        }
    }, [errorQuoteAddFields]);
    useEffect(function () {
        if (errorPlans) {
            showErrorToast(errorPlans, setSeeToast, t);
            onClearPlansData();
        }
    }, [errorPlans]);
    useEffect(function () {
        if (errorPaymentMode) {
            showErrorToast(errorPaymentMode, setSeeToast, t);
            onClearPaymentModeData();
        }
    }, [errorPaymentMode]);
    useEffect(function () {
        if (errorPatchQuote) {
            showErrorToast(errorPatchQuote, setSeeToast, t);
        }
    }, [errorPatchQuote]);
    useEffect(function () {
        if (errorOneQuote) {
            showErrorToast(errorOneQuote, setSeeToast, t);
        }
    }, [errorOneQuote]);
    useEffect(function () {
        if (errorComplete) {
            showErrorToast(errorComplete, setSeeToast, t);
        }
    }, [errorComplete]);
    useEffect(function () {
        if (errorReprintType) {
            showErrorToast(errorReprintType, setSeeToast, t);
        }
    }, [errorReprintType]);
};
